module.exports = __webpack_public_path__ + "img/blc.455ce18d.jpg";